import type { FlightTrackerSearchControlsStrings } from '@skyscanner-internal/landing-pages-shared-types/types-shared/FlightTrackerSearchControlsProps';

const FLIGHT_NUMBER_PATTERN =
  /^(?=[A-Z0-9]{2,3}\d{1,4}$)(?=.*[A-Z])[A-Z0-9]{2,3}\d{1,4}$/;

export const normalizeFlightNumber = (value: string) =>
  value.replaceAll(' ', '').toUpperCase();

export const getValidationError = (
  value: string,
  strings: FlightTrackerSearchControlsStrings,
) => {
  if (!value) {
    return strings.FlightTracker_form_flight_number_error_empty;
  }

  if (!FLIGHT_NUMBER_PATTERN.test(value)) {
    return strings.FlightTracker_form_flight_number_error_invalid;
  }

  return null;
};

export const getFlightTrackerUrl = (flightNumber: string) =>
  `/flight-tracker/${encodeURIComponent(normalizeFlightNumber(flightNumber).toLowerCase())}`;

export const navigateToFlightTracker = (flightNumber: string) => {
  globalThis.window.location.assign(getFlightTrackerUrl(flightNumber));
};
